export default __webpack_public_path__ + "static/media/MAYANK.9db7035d.jpg";